module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1262.03f0e82e.png";